import React from 'react';
import { REDCAT_ICON_DEFAULT_COLOR, REDCAT_ICON_DEFAULT_SIZE, RedcatIconProps } from './RedcatIcon';

const RedcatHistoryIcon = ({
  size = REDCAT_ICON_DEFAULT_SIZE,
  color = REDCAT_ICON_DEFAULT_COLOR,
}: RedcatIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9998 8.32526V12.3253L13.9998 14.3253M3.0498 11.3253C3.2739 9.12532 4.30007 7.08488 5.93254 5.59323C7.56501 4.10158 9.6895 3.26315 11.9007 3.23789C14.1119 3.21264 16.255 4.00233 17.9211 5.4563C19.5872 6.91027 20.6597 8.92674 20.934 11.121C21.2083 13.3152 20.6651 15.5337 19.4082 17.353C18.1512 19.1724 16.2684 20.4653 14.1191 20.9851C11.9697 21.5049 9.70421 21.2152 7.7548 20.1713C5.80539 19.1274 4.30853 17.4024 3.5498 15.3253M3.0498 20.3253V15.3253H8.0498"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RedcatHistoryIcon;
